import Header from './Header'
import Footer from './Footer'
import FullPageLoader from '../Common/FullPageLoader';

const Base = props => (
    <div>
        <Header />
        
        <section className="section-container">
            {props.children}
        </section>

        <Footer />
        <FullPageLoader />
    </div>
)

export default Base;
